// Single source for the energy-savings / Beneficio calculation (used by the dossier page and the dossier list)
const VAUZ_TABLE = { C: [70, 60, 60], D: [125, 100, 100], E: [150, 130, 100] };
export const redondeoAE = (x) => Math.floor(Math.round(x * 1e6) / 1e6);

export const calcularBeneficio = (dossier) => {
  const letra = (dossier?.donnees?.batiment?.zone_climatique || '')[0]?.toUpperCase();
  const anio = dossier?.donnees?.batiment?.annee_construction || 0;
  const sup = dossier?.donnees?.techniques?.superficie_partition || 0;
  const supHabitable = dossier?.donnees?.batiment?.superficie_habitable || 0;
  const cefEspecifico = dossier?.donnees?.techniques?.cef_especifico || 0;
  const tramo = anio <= 1978 ? 0 : anio <= 2006 ? 1 : 2;
  const vauzVal = VAUZ_TABLE[letra] ? VAUZ_TABLE[letra][tramo] : 0;
  const aes = sup * vauzVal;
  const techo = 0.5 * cefEspecifico * supHabitable;
  const aeTotal = vauzVal && cefEspecifico ? redondeoAE(Math.min(aes, techo)) : 0;
  const minEs = aes <= techo ? 'AES' : 'Techo CEF';
  const prixFacture = 8 * sup;
  const valorEconomico = aeTotal > 0 ? (prixFacture / aeTotal) : 0;
  const beneficio = aeTotal * 0.156;
  const beneficioM2 = sup > 0 ? beneficio / sup : 0;
  return { letra, anio, sup, vauzVal, aes, techo, aeTotal, minEs, prixFacture, valorEconomico, beneficio, beneficioM2 };
};
